module.exports = __webpack_public_path__ + "img/welfare_ban.6275c890.png";